import { useState, useEffect } from 'react';
import classnames from 'classnames';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Details from './components/details';
import Artwork from './components/artwork';
import styles from './PageArtwork.module.scss';

import 'swiper/css';
import 'swiper/css/navigation';

const artworkOrdering = [
  'innovationpin',
  'ericbot404',
  'franknitty',
  'keithlam',
  'stephlau',
  'yarliallison',
  'interview',
  'argallery',
];

const timecodes = {
  innovationpin: 0,
  ericbot404: 11,
  franknitty: 189,
  keithlam: 97,
  stephlau: 50,
  yarliallison: 145,
};

function PageArtwork({ page, className, artwork, setPage, currentArtworkMapItem, setArtworkMapItem }) {
  const [swiper, setSwiper] = useState(null);
  const commonProps = {
    artworkOrdering,
    timecodes,
    setPage,
    page,
  };

  useEffect(() => {
    if (!swiper) {
      return;
    }
    switch (artwork) {
      case 'innovationpin':
        swiper.slideTo(0);
        break;
      case 'ericbot404':
        swiper.slideTo(1);
        break;
      case 'franknitty':
        swiper.slideTo(2);
        break;
      case 'keithlam':
        swiper.slideTo(3);
        break;
      case 'stephlau':
        swiper.slideTo(4);
        break;
      case 'yarliallison':
        swiper.slideTo(5);
        break;
      case 'interview':
        swiper.slideTo(6);
        break;
      case 'argallery':
        swiper.slideTo(7);
        break;
      default:
        if (artwork && artwork.startsWith('interview-')) {
          swiper.slideTo(6);
        }
        break;
    }
  }, [swiper, artwork]);

  return (
    <main className={ classnames(styles.container, className) }>
      <Swiper
        modules={ [Navigation] }
        spaceBetween={ 0 }
        slidesPerView={ 1 }
        autoHeight
        speed={ 500 }
        allowTouchMove={ false }
        onSwiper={ setSwiper }
      >
        <SwiperSlide>
          <>
            <Artwork artwork="innovationpin" {...commonProps} />
            <Details artwork="innovationpin" {...commonProps} />
          </>
        </SwiperSlide>
        <SwiperSlide>
          <>
            <Artwork artwork="ericbot404" {...commonProps} />
            <Details artwork="ericbot404" {...commonProps} />
          </>
        </SwiperSlide>
        <SwiperSlide>
          <>
            <Artwork artwork="franknitty" {...commonProps} />
            <Details artwork="franknitty" {...commonProps} />
          </>
        </SwiperSlide>
        <SwiperSlide>
          <>
            <Artwork artwork="keithlam" {...commonProps} />
            <Details artwork="keithlam" {...commonProps} />
          </>
        </SwiperSlide>
        <SwiperSlide>
          <>
            <Artwork artwork="stephlau" {...commonProps} />
            <Details artwork="stephlau" {...commonProps} />
          </>
        </SwiperSlide>
        <SwiperSlide>
          <>
            <Artwork artwork="yarliallison" {...commonProps} />
            <Details artwork="yarliallison" {...commonProps} />
          </>
        </SwiperSlide>
        <SwiperSlide>
          <>
            <Artwork artwork="interview" {...commonProps} />
            <Details artwork="interview" {...commonProps} />
          </>
        </SwiperSlide>
        <SwiperSlide>
          <>
            <Artwork artwork="argallery" {...commonProps} currentArtworkMapItem={ currentArtworkMapItem } setArtworkMapItem={ setArtworkMapItem } />
            <Details artwork="argallery" {...commonProps} />
          </>
        </SwiperSlide>
      </Swiper>
    </main>
  );
}

export default PageArtwork;